export class WrongUserSelectedError extends Error {
  expectedUser?: string;

  constructor(params?: { message?: string; expectedUser?: string }) {
    super(params?.message);
    this.expectedUser = params?.expectedUser;
  }
}
